module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [(_vm.feedbackUrl) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [_c('button', {
    on: {
      "click": _vm.openFeedback
    }
  }, [_c('i', {
    staticClass: "fas fa-comment"
  }), _vm._v(" Feedback")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15deea28","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1115
// module chunks = 1